import { Form, InputGroup } from 'react-bootstrap'
import React from 'react'
import Link from 'next/link'

export const CardReturnOrder = ({ order }) => {
    const [checkAllOrders, setCheckAllOrders] = React.useState(false)
    return (
        <div className={'CardReturnOrder'}>
            <div className={'header'}>
                <h2>Заказ №{order.orderNumber}</h2>
                <InputGroup>
                    <label htmlFor="check-all-items">Вернуть все товары</label>
                    <Form.Check
                        checked={checkAllOrders}
                        onChange={() => setCheckAllOrders(!checkAllOrders)}
                        id={'check-all-items'}
                    />
                </InputGroup>
            </div>
            <div className={'main'}>
                <div className={'row-item'}>
                    <h3>Дата заказа:</h3>
                    <p>{order.orderDate}</p>
                </div>
                <div className={'row-item'}>
                    <h3>Дата доставки:</h3>
                    <p>{order.dateDelivery}</p>
                </div>
                <div className={'row-item'}>
                    <h3>Адрес доставки:</h3>
                    <p>{order.addressDelivery}</p>
                </div>
                <div className={'row-item'}>
                    <h3>Сумма заказа:</h3>
                    <p>{order.amount.toLocaleString('RU-ru')} ₽</p>
                </div>
                <div className={'orders'}>
                    {order.orders.map((item) => (
                        <div key={item.id} className={'order-item'}>
                            <img src={item.img} alt="order-image" />
                            <div className={'order-info'}>
                                <div className={'row-item'}>
                                    <h3>Наименование:</h3>
                                    <p>{item.orderName} ₽</p>
                                </div>
                                <div className={'row-item'}>
                                    <h3>Количество:</h3>
                                    <p>{item.count} ₽</p>
                                </div>
                                <div className={'row-item'}>
                                    <h3>Стоимость:</h3>
                                    <p>
                                        {item.price.toLocaleString('RU-ru')} ₽
                                    </p>
                                </div>
                            </div>
                            <div className={'actions'}>
                                <Form.Check
                                    disabled={true}
                                    checked={checkAllOrders}
                                />
                                <Link href={''}>Оставить отзыв</Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <button disabled={!checkAllOrders}>Оформить возврат</button>
        </div>
    )
}
